import cx from 'classnames';

interface PageProps {
  children: React.ReactNode | React.ReactNode[];
  bgColor?: string;
  className?: string;
}

const Page = ({ children, bgColor, className }: PageProps) => {
  return (
    <div
      style={{
        ...(bgColor && { backgroundColor: bgColor }),
      }}
      className={cx('min-h-screen overflow-x-hidden', className)}
    >
      {children}
    </div>
  );
};

export default Page;
